import * as SystemActions from './../../system/actions/system.actions';
import { initialRegistrationKiwiSaverEntityState, IRegistrationKiwiSaverEntityState } from './../../state/registration-kiwisaver.state';
import * as RegistrationKiwiSaverActions from '../actions/registration-kiwisaver.actions';

export function RegistrationKiwiSaverEntityReducer(state = initialRegistrationKiwiSaverEntityState, action: RegistrationKiwiSaverActions.RegistrationKiwiSaverActions | SystemActions.SystemActions): IRegistrationKiwiSaverEntityState {
    switch (action.type) {
        case RegistrationKiwiSaverActions.REGISTER_KIWISAVER_UPDATE_ENTITY: {
            const { EntityId, EntityName, LegalEntityType } = action.payload;
            return {
                ...state,
                entityId: EntityId,
                entityName: EntityName,
                legalEntityType: LegalEntityType
            };
        }
        case SystemActions.CLEAR_SYSTEM:
            return initialRegistrationKiwiSaverEntityState;
        default: {
            return state;
        }
    }
}
